import React, { useRef } from "react";
import SelectDropdown from "../Select/SelectDropdown";
import { timeFrame, events } from "../../../constants/constants";
import Button from "@atlaskit/button/standard-button";
import RefreshIcon from "@atlaskit/icon/glyph/refresh";
import FilterIcon from "@atlaskit/icon/glyph/filter";
import SearchIcon from "@atlaskit/icon/glyph/search";
import Textfield from "@atlaskit/textfield";
import Form, { Field, ErrorMessage } from "@atlaskit/form";
import CrossCircleIcon from "@atlaskit/icon/glyph/cross-circle";

import styles from "./FilterContainer.module.css";
import { sortAlhabetically } from "../../../helpers/helpers";
const FilterContainer = (props) => {
  const validate = useRef("");
  return (
    <div className={styles.filtersandrefreshparentdiv}>
      <div className={styles.selectContainer}>
        <div className={styles.searchbarcontainer}>
          <Form
            onSubmit={(data) => {
              props.handleSearchKeySumbit(data);
            }}
            isDisabled={props.isLoading}
          >
            {({ formProps }) => (
              <form {...formProps}>
                <div
                  className={styles.filterItem}
                  // style={{ marginTop: "18px", width: "150px" }}
                >
                  <Field
                    name="searchKey"
                    defaultValue={props.searchKey}
                    // validate={async (value) => {
                    //   const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");
                    //   if (regexp.test(value)) {
                    //     return undefined;
                    //   } else {
                    //     return "Please Enter Valid Search Key";
                    //   }
                    // }}
                  >
                    {({ fieldProps, error }) => (
                      <>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                            gap: "2px",
                            marginTop: "-8px",
                          }}
                        >
                          <Textfield
                            elemAfterInput={
                              <div
                                style={{
                                  paddingRight: "6px",
                                  lineHeight: "100%",
                                }}
                              >
                                <SearchIcon
                                  size="small"
                                  borderColor="transparent"
                                />
                              </div>
                            }
                            placeholder="Search by Key"
                            {...fieldProps}
                            onChange={(value) => {
                              props.onChangeSearchKey(value.target.value);
                              fieldProps.onChange(value);
                              const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");

                              if (regexp.test(value.target.value)) {
                                validate.current = "";
                              } else {
                                validate.current = "error";
                              }
                            }}
                          />
                          {props.searchKey.length !== 0 && (
                            <Button
                              size="small"
                              appearance="subtle"
                              onClick={() => {
                                props.onChangeSearchKey("");
                                props.setRefreshPage((prev) => !prev);
                              }}
                            >
                              <CrossCircleIcon
                                size="small"
                                borderColor="transparent"
                              />
                            </Button>
                          )}
                        </div>
                        {error ? (
                          <ErrorMessage>{error}</ErrorMessage>
                        ) : validate.current === "error" ? (
                          <ErrorMessage>Please enter a valid text</ErrorMessage>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </Field>
                </div>
              </form>
            )}
          </Form>
        </div>

        {!props.searchKey ? (
          <div className={styles.filterItem}>
            <SelectDropdown
              selectType="radio"
              inputId="timeFrame"
              optionData={timeFrame}
              placeholder="Timeframe"
              defaultValue={{ label: "Last 24 hours", value: "lastDay" }}
              onEventChange={props.onTimeframeChange}
              disabled={props.isLoading}
              selectedValue={props.timeframeValue}
            />
          </div>
        ) : (
          ""
        )}
        {!props.searchKey ? (
          <div className={styles.filterItem}>
            <SelectDropdown
              selectType="checkbox"
              inputId="project"
              optionData={sortAlhabetically(props.projectList)}
              placeholder="Projects"
              onEventChange={(e) => props.onProjectChange(e)}
              disabled={props.isLoading}
              selectedValue={props.projectValues}
            />
          </div>
        ) : (
          ""
        )}
        {!props.searchKey ? (
          <div className={styles.filterItem}>
            <SelectDropdown
              selectType="checkbox"
              inputId="eventType"
              optionData={sortAlhabetically(events)}
              placeholder="Event Type"
              onEventChange={(e) => props.onEventChange(e)}
              disabled={props.isLoading}
              selectedValue={props.eventValues}
            />
          </div>
        ) : (
          ""
        )}
        {!props.searchKey ? (
          <div className={styles.filterItem}>
            <SelectDropdown
              selectType="checkbox"
              inputId="initiator"
              // optionData={sortAlhabetically(props.initiatorList)}
              optionData={sortAlhabetically(props.initiators)}
              placeholder="Initiator"
              onEventChange={(e) => props.onInitiatorChange(e)}
              disabled={props.isLoading}
              selectedValue={props.initiatorValues}
            />
          </div>
        ) : (
          ""
        )}
        {!props.searchKey ? (
          <div className={styles.filterItem}>
            <SelectDropdown
              selectType="checkbox"
              inputId="issueType"
              optionData={sortAlhabetically(props.issueTypeList)}
              placeholder="Issue Type"
              onEventChange={(e) => props.onIssueTypeChange(e)}
              disabled={props.isLoading}
              selectedValue={props.issueTypeValues}
            />
          </div>
        ) : (
          ""
        )}
        {/* {!props.searchKey ? (
          <div style={{ paddingBottom: "5px" }}>
            <Button
              appearance="subtle"
              type="submit"
              onClick={props.handleFilters}
              iconBefore={<FilterIcon size="small"></FilterIcon>}
              isDisabled={props.isLoading}
            >
              Apply filters
            </Button>
          </div>
        ) : (
          ""
        )} */}
      </div>

      <div className={styles.buttonContainer}>
        {!props.searchKey ? (
          <div>
            <Button
              appearance="default"
              type="submit"
              onClick={props.handleFilters}
              iconBefore={<FilterIcon size="small"></FilterIcon>}
              isDisabled={props.isLoading}
            >
              Apply filters
            </Button>
          </div>
        ) : (
          ""
        )}
        {/* <div style={{ marginTop: "20px" }}>
          <Button
            onClick={props.handleRefreshPage}
            iconBefore={<RefreshIcon size="medium" />}
          >
            Refresh
          </Button>
        </div> */}
        <div>
          <Button
            appearance="subtle"
            onClick={props.handleRefreshPage}
            iconBefore={<RefreshIcon size="medium" />}
          ></Button>
        </div>
        <div className={styles.totalCount}>
          <strong>Selected Issues: {props.checkedIssues.length}</strong>{" "}
        </div>
        {/* <div style={{ marginTop: "30px" }}>
          <strong>
            Total count:
            {props.isLoading ? (
              <Spinner size="xsmall" appearance="invert" />
            ) : (
              props.tableCount
            )}
          </strong>
        </div> */}
      </div>
    </div>
  );
};
export default FilterContainer;
